"use strict";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.CacheManager = void 0;
var _types = require("../types"),
  _logging = require("../logging");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var CacheManager = /*#__PURE__*/function () {
  function CacheManager(a) {
    _classCallCheck(this, CacheManager);
    _defineProperty(this, "cacheMap", new Map()), _defineProperty(this, "intervalId", null), _defineProperty(this, "cleanupTimeout", void 0), this.cleanupTimeout = a * _types.Milliseconds.Second;
  }
  return _createClass(CacheManager, [{
    key: "add",
    value: function add(a) {
      var b = a.key,
        c = a.data,
        d = a.lifetime;
      _logging.KameleoonLogger.debug(_templateObject || (_templateObject = _taggedTemplateLiteral(["CALL: CacheManager.add(key: ", ", data: ", ", lifetime: ", ")"])), b, c, d), null === this.intervalId && this.activate();
      var e = d * _types.Milliseconds.Second,
        f = {
          data: c,
          expirationTime: Date.now() + e
        };
      this.cacheMap.set(b, f), _logging.KameleoonLogger.debug(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["RETURN: CacheManager.add(key: ", ", data: ", ", lifetime: ", ")"])), b, c, d);
    }
  }, {
    key: "getAliveItem",
    value: function getAliveItem(a) {
      _logging.KameleoonLogger.debug(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["CALL: CacheManager.getAliveItem(key: ", ")"])), a);
      var b = this.cacheMap.get(a);
      if (b && b.expirationTime >= Date.now()) {
        var c = b.data;
        return _logging.KameleoonLogger.debug(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["RETURN: CacheManager.getAliveItem(key: ", ") -> (item: ", ")"])), a, c), c;
      }
      return b && this.cacheMap["delete"](a), _logging.KameleoonLogger.debug(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["RETURN: CacheManager.getAliveItem(key: ", ") -> (item: null)"])), a), null;
    }
  }, {
    key: "activate",
    value: function activate() {
      var _this = this;
      this.intervalId = setInterval(function () {
        var a = Date.now();
        var _iterator = _createForOfIteratorHelper(_this.cacheMap),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _ref = _step.value;
            var _ref2 = _slicedToArray(_ref, 2);
            var b = _ref2[0];
            var c = _ref2[1];
            c.expirationTime < a && _this.cacheMap["delete"](b);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        _this.cacheMap.size || _this.cleanupInterval();
      }, this.cleanupTimeout);
    }
  }, {
    key: "cleanupInterval",
    value: function cleanupInterval() {
      this.intervalId && (clearInterval(this.intervalId), this.intervalId = null);
    }
  }]);
}();
exports.CacheManager = CacheManager;